export default __webpack_public_path__ + "static/media/press-18.817b7f61.jpg";